import { Component } from '@angular/core';
import {BreadcrumbComponent} from '@pes/ui';

@Component({
  selector: 'lbpa-fil-ariane',
  templateUrl: './lbpa-fil-ariane.component.html',
  styleUrls: ['./lbpa-fil-ariane.component.scss']
})
export class LbpaFilArianeComponent extends BreadcrumbComponent {

  constructor() {
    super();
  }

}



// WEBPACK FOOTER //
// ./src/app/component/lbpa-fil-ariane/lbpa-fil-ariane.component.ts